import React from 'react';
import '../Experience/estilo.scss'

function TimelineItem({timeline}) {
    let timelineItemSide = true; //true = left false = right
    let timelineClassName = timelineItemSide ? "timeline-content js--fadeInLeft" : "timeline-content js--fadeInRight"
    return (
        <div>
            {timeline.item.map((item, index) => {
                if (index % 2 === 0){
                    timelineItemSide = true;
                } else {
                    timelineItemSide = false;
                }
                return <div key={index} className="timeline-item">
                    <div className="timeline-img"></div>
                    <div className={timelineClassName}>
                        <h3>{item.role}</h3>
                        <h4>{item.company}</h4>
                        <div className="date">{item.date}</div>
                        {item.list.map((list, index) => {
                            return <ul className="timeline-list-title" key={index}>
                                <p><strong>{list.title}</strong></p>
                                {list.subTitle.map((subTitle, index) => {
                                    return <li className= "timeline-list-item" key={index}>{subTitle}</li>
                                })}
                            </ul>
                        }
                        )}
                    </div>
                </div>
            }
            )}
        </div>
    );
}

export default TimelineItem;